import type { HttpPost } from '@/shared/infra/http'
import type { AcknowledgeAnnouncement } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'
import { type AnnouncementDto, toAnnouncement } from './announcement-dto'

type AcknowledgeAnnouncementResponseDto = {
  announcement: AnnouncementDto
}

export class EdgeAcknowledgeAnnouncementRepository {
  constructor(private readonly http: HttpPost) {}

  execute: AcknowledgeAnnouncement = async (params) => {
    try {
      const data = await this.http.post<unknown, AcknowledgeAnnouncementResponseDto>({
        url: `/connect/announcements/${encodeURIComponent(params.announcementId)}/ack`,
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
        },
      })
      return { announcement: toAnnouncement(data.announcement) }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
